/* eslint no-console: 0 */

import Vue from 'vue/dist/vue.esm';

import bottomNav from 'bottom-nav';
Vue.component('bottom-nav', bottomNav);

document.addEventListener('DOMContentLoaded', () => {
  var messageApp = new Vue({
    el: '#userAccount',
    data: {
      new_attachment: "",
      show_attachment_preview: false,
      attachment_preview: "",
      screen_name: null,
      first_name: null,
      last_name: null,
      email: null,
      password_input: "",
      confirm_password: "",
      agreed_terms: false,
      show_modal: false,
      terms_viewed: false, 
      content_changes: false,
    },
    methods: {
      toggleModal() {
        this.terms_viewed = true;
        this.show_modal = !this.show_modal;
      },
      handleAttachmentPreview() {
        let reader  = new FileReader();
        reader.addEventListener("load", function () {
          this.attachment_preview = reader.result;
        }.bind(this), false);

        reader.readAsDataURL( this.new_attachment );
      },
      handleFileSelection(e) {
        this.new_attachment = this.$refs.new_attachment.files[0];

        if (this.new_attachment) {
          let reader  = new FileReader();
          reader.addEventListener("load", function () {
            this.show_attachment_preview = true;
            this.attachment_preview = reader.result;
          }.bind(this), false);

          if ( /\.(jpe?g|png|gif)$/i.test( this.new_attachment.name ) ) {
            reader.readAsDataURL( this.new_attachment );
          }
        }
      },
      contentChanged() {
        this.content_changes = true
      },
      resetAttachment() {
        this.show_attachment_preview = false;
        this.new_attachment = "";
        this.attachment_preview = "";
      },
      agreeTerms() {
        this.agreed_terms = true;
        this.show_modal = false;
      }
    },
    computed: {
      validateForm() {
        if (
            this.password_input.length >= 6
            && this.confirm_password.length == this.password_input.length
            && this.terms_viewed
            && this.agreed_terms
            && this.screen_name
            && this.first_name
            && this.last_name
            && this.email
        ) {
          return true;
        }

        return false;
      },
      validateAgreedTerms() {
        return this.agreed_terms ? true : false;
      }
    }
  });
});
